export const NEXUDUS_TOKEN_COOKIE_NAME = 'nexudus.auth.public.v4.token';
export const NEXUDUS_TOKEN_EXPIRY_NAME = 'nexudus.auth.public.v4.expiry';
